import React, { Component } from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import _ from 'lodash';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Typeahead } from 'react-bootstrap-typeahead';
import FleetService from '../../../services/FleetService';

class VehicleMake extends Component {

  vehicleMake = [];

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      controls: props.controls || {}
    };
    this.getVehicleMake();
  }

  async getVehicleMake() {
    try {
      const { controls } = this.state;
      const { vehicleType } = controls;
      let reqData = { vehicle_type_id: vehicleType.value.vehicle_type_id };
      if (this.props.temp_id) {
        reqData.temp_id = this.props.temp_id;
      }
      const { data } = await FleetService.getVehicalMake(reqData);

      if (data) {
        this.vehicleMake = data.data;
        _.forEach(this.props.fleetData, (fleet) => {
          if ((fleet.type || '') === (vehicleType.value.name || '').toLowerCase()) {
            _.forEach(fleet.data, (d) => {
              _.remove(this.vehicleMake, { 'brand_id': d.vehicle_type_brand_id });
            });
          }
        });
      }

      this.setState((prevState) => {
        return { ...prevState };
      });
    } catch (error) {
      console.log(error);
    }
  }

  goBack = () => {
    const { controls } = this.state;
    this.props.updateState({ visibleArea: 'vehicleType', controls });
  }

  onSelectVehicleMake(item) {
    const { controls } = this.state;
    controls.vehicleBrand.value = item;
    this.setState({ controls });
    this.props.updateState({ visibleArea: 'vehicleCount', controls });
  }

  render() {
    return (
      <>
        <Row className="fleet-customer-details-label">
          <Col xl="10" xs="10" ms="10" style={{ display: 'flex' }}>
            <FontAwesomeIcon onClick={this.goBack} icon={faAngleLeft} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
            &nbsp;&nbsp;
            <span style={{ marginTop: '2px' }}>VEHICLE MAKE</span>
          </Col>
          <Col>
            <FontAwesomeIcon className="pull-right" onClick={this.props.onCancelClick} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <FormGroup>
              <Label className="input-label">Please select the company of your vehicle</Label>
              <div className="d-flex-row vehical-sku-id-search">
                <Typeahead
                  filterBy={(option, props) => {
                    if (props.selected.length) {
                      return true;
                    }
                    return option.name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1 || option.name.toLowerCase().indexOf('other') !== -1;
                  }}
                  labelKey="name"
                  options={this.vehicleMake}
                  placeholder="Search..."
                  onChange={(selectedMake) => this.onSelectVehicleMake(selectedMake[0])}
                />
                <FontAwesomeIcon className="serach-icon" icon={faSearch} color="#6e777f" />
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row style={{ marginLeft: '0', marginTop: '20px' }}>
          {
            this.vehicleMake.map((item, index) => (
              index < 12 && <Col xl="4" md="6" ms="6" xs="6" sm="6" className={classnames({ 'active-vehical-make-wrapp': this.brand_id === item.brand_id }, 'vehical-make-wrapp custom-secondary')} style={{ display: 'flex', maxWidth: '132px', cursor: 'pointer' }} key={item.name}>
                <div title={item.name} onClick={() => this.onSelectVehicleMake(item)} className="d-flex-column" style={{ margin: 'auto', textTransform: 'uppercase' }}>
                  <img src={item.image_url || 'images/no-image-available.jpg'} alt={item.name} className="vehical-make-img" />
                  <span className="vehical-make-label">{item.name}</span>
                </div>
              </Col>
            ))
          }
        </Row>
        <span className="Note---If-you-can-no">
          Note - If you can not find the company of your vehicle, please use the search bar to search for it.
        </span>
      </>
    );
  }
}

export default VehicleMake;